import { Box, Stack, Checkbox, FormControlLabel, Button } from '@mui/material'
import { EMPLOYEE_STATUS } from 'app/employees/constants'
import useFilterEmployee from 'app/employees/hooks/useFilterEmployee'
import type { UseFilter } from 'types/table'

export default function EmployeeStatus() {
  const { filterEmployee, onChangeValue, onClearFilters, onAddUrlFilters } =
    useFilterEmployee()

  return (
    <Box padding={2}>
      {EMPLOYEE_STATUS.map(({ id, label }) => {
        const value =
          filterEmployee.status.find(item => item.id === id) ||
          ({} as UseFilter)
        return (
          <Stack key={id} direction="row" marginBottom={2}>
            <FormControlLabel
              onChange={(_, checked) =>
                onChangeValue({
                  filter: { id, label, checked },
                  name: 'status'
                })
              }
              checked={(value.checked as boolean) || false}
              label={label}
              control={<Checkbox />}
              componentsProps={{
                typography: {
                  variant: 'h5'
                }
              }}
            />
          </Stack>
        )
      })}
      <Stack direction="row" spacing={2}>
        <Button fullWidth onClick={() => onClearFilters('status')}>
          Clear
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={() => onAddUrlFilters('status')}
        >
          Apply
        </Button>
      </Stack>
    </Box>
  )
}
